var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17V7C20 4.832 16.337 3 12 3C7.663 3 4 4.832 4 7V17C4 19.168 7.663 21 12 21C16.337 21 20 19.168 20 17ZM12 5C15.691 5 17.931 6.507 18 6.994C17.931 7.493 15.691 9 12 9C8.309 9 6.069 7.493 6 7.006C6.069 6.507 8.309 5 12 5ZM6 9.607C7.479 10.454 9.637 11 12 11C14.363 11 16.521 10.454 18 9.607V11.994C17.931 12.493 15.691 14 12 14C8.309 14 6.069 12.493 6 12V9.607ZM6 17V14.607C7.479 15.454 9.637 16 12 16C14.363 16 16.521 15.454 18 14.607V16.994C17.931 17.493 15.691 19 12 19C8.309 19 6.069 17.493 6 17Z",
    fill: "#1C1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2);
export default __webpack_public_path__ + "static/media/Icons-2.916ce3432a38fc40ff2bf3b24e268379.svg";
export { ForwardRef as ReactComponent };